var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98286 2.95845C7.22694 2.71437 7.62267 2.71437 7.86675 2.95845L13.3001 8.39178C14.1858 9.27753 14.1858 10.7233 13.3001 11.609L7.86675 17.0423C7.62267 17.2864 7.22694 17.2864 6.98286 17.0423C6.73879 16.7983 6.73879 16.4025 6.98286 16.1584L12.4162 10.7251C12.8138 10.3275 12.8138 9.67326 12.4162 9.27567L6.98286 3.84233C6.73879 3.59825 6.73879 3.20253 6.98286 2.95845Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxArrowRight);
export default __webpack_public_path__ + "static/media/vuesax_arrowRight.2523394bd1491a7b401cbdc0cb9204cd.svg";
export { ForwardRef as ReactComponent };